import React from 'react';
import { Spacer } from '@ontruck/orc';

import { HeightCell, AmountCell, booleanToText } from 'utils/format';

import ChangeRow from './utils/ChangeRow';
import NewStop from './utils/NewStop';
import { t, EXTRAS } from './utils/constants';

const createShipperOrderRenderer = ({ changes, ...props }) => {
  if (!Object.keys(changes || {}).length) {
    return null;
  }

  return (
    <Spacer {...props} data-testid="create_shipper_order_log">
      <ChangeRow
        label={t.price}
        value={<AmountCell currency={changes?.currency} value={changes?.net_full_price} />}
      />
      <Spacer mTop="XS">
        {changes?.stops?.map((stop) => (
          <NewStop stop={stop} key={stop?.stop_number} />
        ))}
      </Spacer>
      {[EXTRAS.SIDE_LOAD, EXTRAS.TOP_LOAD, EXTRAS.LIFTGATE].map(
        (extra) =>
          changes?.vehicle_extras?.includes(extra) && (
            <ChangeRow
              label={t[extra]}
              value={booleanToText(changes?.vehicle_extras?.includes(extra))}
              key={extra}
            />
          )
      )}
      <ChangeRow label={t.max_height} value={<HeightCell height={changes?.max_height} />} />
    </Spacer>
  );
};

export default createShipperOrderRenderer;
